/* eslint-disable */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function LocationRedirect({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Convert sessionStorage string → boolean safely
  const locatePassed = sessionStorage.getItem("LocateCheckPassed") === "true";
  const isLocatePage = location.pathname === "/locate-check";

  useEffect(() => {
    // 1️⃣ If not passed → always go to locate-check
    if (!locatePassed && !isLocatePage) {
      navigate("/locate-check", { replace: true });
      return;
    }

    // 2️⃣ If passed and user tries to open locate-check → go home
    if (locatePassed && isLocatePage) {
      navigate("/", { replace: true });
      return;
    }
  }, [locatePassed, isLocatePage, navigate]);

  // ✅ Avoid blank screen — always render children
  return children;
}

export default LocationRedirect;
